(function (angular) {
    angular.module('bizPartEngage').controller('core.register', registerController);

    registerController.$inject = ["$rootScope", "core.registerService", "$mdDialog", "$translate", "bizValidationService", "$mdToast"];

    function registerController($rootScope, registerService, $mdDialog, $translate, bizValidationService, $mdToast) {
        var vm = this;
        vm.Register = Register;
        vm.AcceptedConditions = false;
        vm.Init = Init;
        vm.Roles = [];
        vm.User = {};
        vm.Message = '';

        vm.Init();
        function Init() {
            
        }

        function Register()
        {
            if (bizValidationService.FormValid(vm.MyForm) == true && vm.AcceptedConditions == true)
            {
                vm.User.IsActive = true;
                vm.User.CultureId = $rootScope.LoggedInUser.CurrentCultureId;
                vm.User.strCulture = $rootScope.Cultures.GetItemByValue('Id', $rootScope.LoggedInUser.CurrentCultureId).CultureCode;
                vm.Password = vm.Password.trim();

                registerService.CreateUser(vm.User, vm.Password).then(registerSuccess);

                function registerSuccess(response)
                {
                    if (response.data.Success == true)
                    {
                        //$mdToast.show($mdToast.simple()
                        //    .content('User Created, you can now use the information entered to log on to the site')
                        //    .position('bottom right')
                        //);
                        $translate('CORE.REGISTER.USERCREATED').then(function (translation) {
                        	vm.Message = translation || 'User Created, you can now use the information entered to log on to the site';
                        });
                    }
                    else {
                        //$mdToast.show($mdToast.simple()
                        //    .content(response.data.Message)
                        //    .position('bottom right')
                        //);
                        vm.Message = response.data.Message;
                    }
                }
            }
        }
    }
})(window.angular);
